<ng-container *ngIf="downloadAttachment$ | async"></ng-container>

<div data-testid="contourEditor" class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Редактор контура</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="p-0 m-0" fusePerfectScrollbar>
    <mat-tab-group class="h-full" [selectedIndex]="activeTab">
      <mat-tab i18n-label label="Облицовка" *ngIf="presetSettings.componentsAvailability.outlineEditor.butts">
        <div class="p-4 h-full flex flex-col">
          <csl-butt-form
            [postforming]="postforming"
            [editable]="editable"
            #buttForm
            [matInMatBaseId]="matInMatBaseId"
            [mainMaterial]="mainMaterial"
            [panel]="panel"
            (formChanged)="onButtFormChanged($event)"
            >Loading…</csl-butt-form
          >
        </div>
      </mat-tab>

      <mat-tab i18n-label label="Обработка угла" *ngIf="presetSettings.componentsAvailability.outlineEditor.angles">
        <div class="flex flex-col h-full">
          <csl-angle-form
            [angleProcessingAvailability]="
              presetSettings.componentsAvailability.outlineEditor.angleProcessingAvailability
            "
            class="h-full w-full"
            [materialType]="mainMaterial.type"
            [editable]="editable"
            [userOptions]="userOptions"
            #angleForm
            [panel]="panel"
            (formChanged)="onAnglesFormChanged($event)"
            >Loading…
          </csl-angle-form>
        </div>
      </mat-tab>

      <mat-tab i18n-label label="Вырезы" *ngIf="presetSettings.componentsAvailability.outlineEditor.cutouts">
        <div class="flex flex-col h-full">
          <csl-plate-cutout-form
            class="w-full h-full ps"
            [panel]="panel"
            [editable]="editable"
            [groupId]="mainMaterial.inMaterialBaseGroupId"
            (formChanged)="onCutoutsFormChanged($event)"></csl-plate-cutout-form>
        </div>
      </mat-tab>

      <mat-tab i18n-label label="Пазы" *ngIf="presetSettings.componentsAvailability.outlineEditor.slots">
        <div class="p-4 h-full flex flex-col">
          <csl-groove-form
            [editable]="editable"
            #slotForm
            [panel]="panel"
            [material]="mainMaterial"
            (formChanged)="onGrooveFormChanged($event)"
            >Loading...
          </csl-groove-form>
        </div>
      </mat-tab>

      <mat-tab i18n-label label="Присадка" *ngIf="presetSettings.componentsAvailability.outlineEditor.fasteners">
        <div class="flex flex-col h-full">
          <csl-fasteners-form
            class="flex-auto flex-col"
            [editable]="editable"
            [mainMaterialThickness]="mainMaterial.thickness"
            [panel]="panel"
            (formCustomHolesChanged)="onCustomHolesFormChanged($event)"
            >Loading…
          </csl-fasteners-form>
        </div>
      </mat-tab>

      <mat-tab
        i18n-label
        label="Облицовка пласти"
        *ngIf="presetSettings.componentsAvailability.outlineEditor.faceBanding">
        <div class="p-4 h-full flex flex-col">
          <csl-face-banding
            class="flex flex-auto flex-col justify-start items-stretch"
            [editable]="editable"
            [panel]="panel"
            [bands]="panel.panelOutline.faceBanding"
            [mainMaterial]="mainMaterial"
            (formChanged)="onFaceBandingFormChanged($event)"
            >Loading…
          </csl-face-banding>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div mat-dialog-actions>
    <div class="flex-1 flex justify-start items-center">
      <input
        #uploadFileInput
        type="file"
        (change)="addAttachment($any($event.target).files[0]); $any($event.target).value = null"
        hidden />
      <button
        i18n-matTooltip
        [disabled]="!editable"
        matTooltip="Прикрепить файл"
        mat-raised-button
        color="accent"
        (click)="uploadFileInput.click()"
        *ngIf="!panel.attachmentName">
        <mat-icon class="mat-24 white-fg" aria-label="">attach_file</mat-icon>
      </button>

      <button
        i18n-matTooltip
        [disabled]="!editable || !paramsValid"
        matTooltip="Создать зеркальную панель"
        mat-raised-button
        color="accent"
        (click)="
          dialogRef.close({ panel: panel, attachmentName: panel.attachmentName }); createMirrorPanel.emit(panel)
        ">
        <mat-icon svgIcon="mirror_flip" class="mat-24 white-fg" aria-label=""></mat-icon>
      </button>

      <button
        i18n-matTooltip
        [disabled]="!editable || !paramsValid"
        matTooltip="Создать копию панели"
        mat-raised-button
        color="accent"
        (click)="clonePanel(panel)">
        <mat-icon svgIcon="content_copy" aria-label="" class="white-fg"></mat-icon>
      </button>

      <button
        i18n-matTooltip
        [disabled]="!editable || !paramsValid || isLinearMaterial || hasFasteners() || hasCutouts()"
        matTooltip="Повернуть панель против часовой стрелки"
        mat-raised-button
        color="accent"
        (click)="rotatePanelCounterclockwise(panel)">
        <mat-icon aria-label="" class="white-fg">rotate_90_degrees_ccw</mat-icon>
      </button>

      <button
        i18n-matTooltip
        [disabled]="!editable || !paramsValid || isLinearMaterial || hasFasteners() || hasCutouts()"
        matTooltip="Повернуть панель по часовой стрелке"
        mat-raised-button
        color="accent"
        (click)="rotatePanelClockwise(panel)">
        <mat-icon class="white-fg -scale-x-1">rotate_90_degrees_ccw</mat-icon>
      </button>

      <mat-chip-list *ngIf="panel.attachmentName" class="ml-4">
        <mat-chip class="my-1" [removable]="true" (removed)="removeAttachment()" selected="true">
          <span>{{ panel.attachmentName }}</span>
          <mat-icon class="download-attach-btn" (click)="onDownloadAttachment()">download</mat-icon>
          <mat-icon matChipRemove *ngIf="editable">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>

    <button i18n mat-raised-button class="mat-accent mr-4" [disabled]="!editable" (click)="saveAndClose()">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
